import React, { FC } from 'react';
import { Timeline } from 'antd';
import styled from 'styled-components';

import SectionCollapse from '../../common/SectionCollapse';
import DurationStep from './Steps/DurationStep';
import PopulationStep from './Steps/PopulationStep';
import SampleSizeStep from './Steps/SampleSizeStep';

interface EstimateProps {
  isViewMode?: boolean;
}

export const Estimate: FC<EstimateProps> = ({ isViewMode = false }) => {
  return (
    <>
      <SectionCollapse
        title="Population, Duration and Sample Size"
        subtitle="Select the population, duration and sample size you want to engage in this experiment."
        defaultOpen
      >
        <Timeline
          style={{ padding: 16, marginBottom: '-16px' }}
          items={[
            {
              dot: <TimelineStepIndicator>1</TimelineStepIndicator>,
              children: <PopulationStep isViewMode={isViewMode} />,
            },
            {
              dot: <TimelineStepIndicator>2</TimelineStepIndicator>,
              children: <DurationStep isViewMode={isViewMode} />,
            },
            {
              dot: <TimelineStepIndicator>3</TimelineStepIndicator>,
              children: <SampleSizeStep isViewMode={isViewMode} />,
            },
          ]}
        />
      </SectionCollapse>
    </>
  );
};

export const TimelineStepIndicator = styled.div`
  align-items: center;
  background-color: #eef9f9;
  border-radius: 8px;
  color: #005339;
  display: flex;
  height: 40px;
  justify-content: center;
  line-height: 0px;
  margin-top: 16px;
  width: 40px;
`;

export default Estimate;
